// extracted by mini-css-extract-plugin
export default {"video-player":"i2Q4L","videoPlayer":"i2Q4L"};